import { render, staticRenderFns } from "./survey-advanced-cra.vue?vue&type=template&id=4e42339b&scoped=true"
import script from "./survey-advanced-cra.vue?vue&type=script&lang=js"
export * from "./survey-advanced-cra.vue?vue&type=script&lang=js"
import style0 from "./survey-advanced-cra.vue?vue&type=style&index=0&id=4e42339b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e42339b",
  null
  
)

export default component.exports